import { DocumentNumberInput } from '@/components/document-number-input'
import { HelperText } from '@/components/helper-text'
import { GroupInput } from '@/components/v2/group-input'
import { Input } from '@material-tailwind/react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

export const LegalRepresentativeForm = () => {
  const { t } = useTranslation()

  const {
    values,
    handleChange
  } = useFormikContext()

  return (

    <GroupInput
      title={t('company.sections.legalRepresentative')}
      description='Rellena la información del representante legal de la empresa contratista.'
      className='py-8'
    >
      <div className='grid grid-cols-2 gap-4'>
        <Input
          required
          name='legal_representative_attributes.full_name'
          label={t('common.fullName')}
          value={values.legal_representative_attributes.full_name}
          onChange={handleChange}
        />

        <div>
          <DocumentNumberInput
            required
            name='legal_representative_attributes.document_number'
            label={t('documentNumber.one')}
            value={values.legal_representative_attributes.document_number}
            onChange={handleChange}
          />
        </div>

        <Input
          name='legal_representative_attributes.email'
          label={t('email.one')}
          value={values.legal_representative_attributes.email}
          onChange={handleChange}
        />

        <Input
          name='legal_representative_attributes.phone'
          label={t('phone.one')}
          value={values.legal_representative_attributes.phone}
          onChange={handleChange}
        />

      </div>
    </GroupInput>
  )
}
